module.exports = __webpack_public_path__ + "static/home-07133a6151db018141697eff4a9877d6.png";